import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { StockService } from 'src/app/services/stock/stock.service';
import { LocationService } from 'src/app/services/locations/location.service';
import { BranchService } from 'src/app/services/branches/branch.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ExportStockService } from 'src/app/services/stock/export-stock.service';

@Component({
  selector: 'app-all-stock',
  templateUrl: './all-stock.component.html',
  styleUrls: ['./all-stock.component.css']
})
export class AllStockComponent implements OnInit{
  public userPermissions: string[] = [];
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  vehicles: any[] = [];
  searchText: string = '';
  locations: any[] = [];
  branches: any[] = [];
  public isInProgress: boolean = false;
  rowCount: number=0;
  locationId: string|null="";
  branchId:string|null="";

  constructor(
    private stockService:StockService,
    private locationService:LocationService,
    private branchService:BranchService,
    private authService: AuthService,
    private exportStockService: ExportStockService,
  ){}

  ngOnInit(): void {
    this.isInProgress=true;
    this.userPermissions=this.authService.getPermissions();
    this.fetchAllStock();
    this.fetchLocations();
  }

  fetchAllStock():void{
    this.stockService.getAllStock()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.rowCount = this.vehicles.length;
          this.isInProgress=false;
          this.errorMessage=null;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isInProgress=false;
           this.rowCount =0;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isInProgress=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
      }
    });
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

  //Fetch stock by location or branch
  onSelectChange(target: EventTarget|null,option:string) {
    if (target instanceof HTMLSelectElement) {

      if(option==='location'){
        this.locationId = target.value;
      
        if(this.locationId!=='' && this.locationId!==undefined){
          this.isInProgress=true;
          //Save Location ID in session for use when 'All' option is selected on branches
          localStorage.setItem("locationId", this.locationId);
          this.branchId = ""; //Reset branch Id
          
          this.fetchBranchesByLocation(this.locationId);
          this.fetchStockByLocation(this.locationId);
        }else{
          this.branches = []; // Clear the branches
          this.branchId = ""; //Reset branch Id
          this.fetchAllStock();
        }
      }else{
        this.isInProgress=true;
        this.branchId = target.value;
      
        if(this.branchId!=='' && this.branchId!==undefined){
          this.fetchStockByBranch(this.branchId);
        }else{
          this.locationId =localStorage.getItem("locationId");
          this.fetchStockByLocation(this.locationId!);
        }
      }
    }
  }

  fetchLocations():void{
    this.locationService.getAllLocations().subscribe((response: ApiResponse) =>this.locations = response.data);
  }

  fetchBranchesByLocation(locationId: string):void{
    this.branchService.getBranchesByLocation(locationId).subscribe((response: ApiResponse) =>this.branches = response.data);
  }

  fetchStockByLocation(locationId: string):void {
    this.stockService.filterAllStockByLocation(locationId)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.rowCount = this.vehicles.length;
          this.isInProgress=false;
          this.errorMessage=null;
        }else if(response.status==='no_data'){
           this.vehicles=[];
           this.rowCount =0;
           this.errorMessage=response.message;
           this.isInProgress=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isInProgress=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
      }
    });
  }

  fetchStockByBranch(branchId: string):void {
    this.stockService.filterAllStockByBranch(branchId)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.rowCount = this.vehicles.length;
          this.isInProgress=false;
          this.errorMessage=null;
        }else if(response.status==='no_data'){
          this.vehicles=[];
          this.rowCount =0;
          this.errorMessage=response.message;
          this.isInProgress=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isInProgress=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
      }
    });
  }

  exportToExcel(){
    this.isInProgress = true;
    this.exportStockService.exportAllStock(this.locationId,this.branchId)
  .subscribe({
    next: (response: Blob) => {
      this.isInProgress = false;
    
      // Create a download link for the file
      const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'ALL-STOCK.xlsx'; // Set filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.successMessage = "Stock exported successfully!";
      this.errorMessage=null;
    },
    error: (error) => {
      this.isInProgress = false;
      this.errorMessage="Export failed. Please try again!";
      this.successMessage=null
      console.error("Download error:", error);
    }
  });
  }
}
